// Email List Cleaner — the rules both paths share (textarea + file worker),
// so a list cleaned by paste and the same list cleaned from a file agree.

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

// Same separators the textarea path always split on: newlines, commas, semicolons.
export const SEPARATOR_RE = /[\r\n,;]+/;

// RFC 5321 caps a forward-path at 254 chars. Anything longer is not an address,
// and capping it keeps one runaway "line" from inflating a sort chunk.
const MAX_LEN = 254;

export function parseBlacklist(text) {
  return new Set(
    text.split(SEPARATOR_RE)
      .map((d) => d.trim().toLowerCase().replace(/^@/, ''))
      .filter(Boolean),
  );
}

export const DROP_EMPTY = 0;
export const DROP_INVALID = 1;
export const DROP_BLACKLISTED = 2;

/**
 * Classify one raw token: returns the normalised address (a string), or a
 * DROP_* number. Numbers instead of objects because the file path calls this
 * tens of millions of times.
 * Blacklist is applied before dedupe, so every blacklisted occurrence is
 * counted as blacklisted — not as a duplicate of an earlier one.
 */
export function classify(raw, blocked) {
  let email = raw.trim().toLowerCase();
  // CSV / ESP exports quote fields: "a@x.com" must be a@x.com, or a quoted
  // suppression list silently removes nothing. Looped, so classify() is
  // idempotent — the subtract fast path re-classifies this tool's own output.
  while (email.length > 1 && email.charCodeAt(0) === 34 && email.charCodeAt(email.length - 1) === 34) {
    email = email.slice(1, -1).trim();
  }
  if (!email) return DROP_EMPTY;
  if (email.length > MAX_LEN || !EMAIL_RE.test(email)) return DROP_INVALID;
  if (blocked.size && blocked.has(email.slice(email.lastIndexOf('@') + 1))) return DROP_BLACKLISTED;
  return email;
}
